import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "notificationSoundPreference"]
  static values = { deviceUid: String }

  toggle(event) {
    event.preventDefault()
    const pushEnabled = this.checkboxTarget.checked
    const deviceUid = this.deviceUidValue

    if (!deviceUid) {
      alert("Device UID missing!");
      return;
    }

    fetch(`/api/v1/devices`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Device-Uid": deviceUid
      },
      body: JSON.stringify({
        device: { push_enabled: pushEnabled }
      }),
    }).then(() => {
      this.updateSoundFormVisibility(pushEnabled)
    })
  }

  updateSoundFormVisibility(pushEnabled) {
    const notificationSoundSection = document.getElementById('notificationSoundPreference')
    if (notificationSoundSection) {
      notificationSoundSection.classList.toggle('hidden', !pushEnabled)
    }
  }

  updateSoundPreference(event) {
    const value = event.target.value === "false"
    const deviceUid = this.deviceUidValue

    if (!deviceUid) {
      alert("Device UID missing!")
      return
    }

    fetch(`/api/v1/devices`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Device-Uid": deviceUid
      },
      body: JSON.stringify({
        device: { push_sound: value }
      }),
    })
  }
}
